<template>
    <div class="ch-container">
        <el-card>
            <template slot="header">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/bannerNews' }" v-if="
                        typeNumber == '1' ||
                        typeNumber == '2' ||
                        typeNumber == '3' ||
                        typeNumber == '4' ||
                        typeNumber == '6'
                    ">通知公告</el-breadcrumb-item>
                    <!-- <el-breadcrumb-item :to="{ path: '/correct' }" v-if="typeNumber == '3'">更正公告</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/result' }" v-if="typeNumber == '4'">结果公告</el-breadcrumb-item> -->
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
            </template>
            <!-- 资格与预审公告 -->
            <div v-if="typeNumber == '1'">
                <!-- <div class="ch-info-title">{{ detail.projectName }}</div> -->
                <div class="ch-into-item">
                    <!-- <div class="ch-info-item-td ch-info-item-label">公告详情</div> -->
                    <div class="ch-info-item-td ch-info-item-value" v-html="detail.content"></div>
                    <!-- <div class="ch-info-item-td ch-info-item-value">
            <span style="color: #109cee;text-decoration: underline;cursor: pointer;" @click="visible1 = true">查看公告详情</span>
          </div> -->
                </div>
            </div>
            <!-- 采购公告详情  -->
            <div class="ch-info-box" v-if="typeNumber == '2' || typeNumber == '3'">
                <div class="ch-info-title">{{ detail.projectName }}</div>
                <div class="ch-info-tabel">
                    <div class="ch-into-item" v-if="false">
                        <div class="ch-info-item-td ch-info-item-label">项目公告</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            <a :href="detail.projectBulletinUrl">查看原公告</a>
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">项目编号</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.projectCode ? detail.projectCode : "暂无数据" }}
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">招标方式</div>
                        <div class="ch-info-item-td ch-info-item-value">{{ detail.biddingName }}</div>
                    </div>
                    <!-- <div class="ch-into-item">
            <div class="ch-info-item-td ch-info-item-label">采购方式</div>
            <div class="ch-info-item-td ch-info-item-value">{{detail.biddingSubMethodName}}</div>
          </div> -->
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">项目开标时间</div>
                        <div class="ch-info-item-td ch-info-item-value">{{ detail.saleTime }}</div>
                    </div>

                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">开标地点</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.siteName ? detail.siteName : "暂无数据" }}
                        </div>
                    </div>
                    <div v-if="detail.bondFormat" class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">保证金</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.bondFormat }}元
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">最高限价</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.budgetFormat }}元
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">最高限价备注</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.budgetRemark }}
                        </div>
                    </div>
                    <div v-if="detail.bondImg && false" class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">保证金付款码</div>
                        <el-image style="height: 60px; margin-left: 20px" :src="detail.bondImg"
                            :preview-src-list="[detail.bondImg]">
                        </el-image>
                        <!-- <div class="ch-info-item-td ch-info-item-value">{{detail.bondImg}}</div> -->
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">标书文件付费方式</div>
                        <div class="ch-info-item-td ch-info-item-value" v-if="detail.biddingFileInfo != null">
                            <el-image style="height: 60px; margin-left: 20px"
                                :src="detail.biddingFileInfo.imgAlipayPath"
                                :preview-src-list="[detail.biddingFileInfo.imgAlipayPath]">
                            </el-image>
                            <el-image style="height: 60px; margin-left: 20px"
                                :src="detail.biddingFileInfo.imgWechatPath"
                                :preview-src-list="[detail.biddingFileInfo.imgWechatPath]">
                            </el-image>
                            <div>开户名：{{ detail.biddingFileInfo.name }}</div>
                            <div>开户行：{{ detail.biddingFileInfo.openingBank }}</div>
                            <div>银联账号：{{ detail.biddingFileInfo.unionPay }}</div>
                        </div>
                    </div>
                    <!-- <div class="ch-into-item">
            <div class="ch-info-item-td ch-info-item-label">标书类型</div>
            <div class="ch-info-item-td ch-info-item-value">{{ tenderSaleType }}</div>
          </div>
          <div class="ch-into-item">
            <div class="ch-info-item-td ch-info-item-label">包件数量</div>
            <div class="ch-info-item-td ch-info-item-value">{{ detail.packageInfoNum }}</div>
          </div> -->
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">报名时间</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.enrollStart }} 至 {{ detail.enrollEnd }}
                        </div>
                    </div>
                    <!--          <div class="ch-into-item">-->
                    <!--            <div class="ch-info-item-td ch-info-item-label">保证金缴纳截止时间</div>-->
                    <!--            <div class="ch-info-item-td ch-info-item-value">{{detail.marginEndTime}}</div>-->
                    <!--          </div>-->
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">项目联系人</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.leaderName }} {{ detail.leaderPhone }}
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">公示期</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.publicityPeriod }}个工作日
                        </div>
                    </div>

                    <!-- <div class="ch-into-item" style="flex-wrap: wrap;">
            <div class="ch-info-item-td ch-info-item-label">附件</div>
            <div  v-for="(item,index) in 4" style="display: block;">
             <div> {{ detail.attachFileList }}</div>
            </div>
          </div> -->

                    <div class="ch-into-item" v-if="detail.attachFileList && detail.attachFileList.length !== 0">
                        <div class="ch-info-item-td ch-info-item-label">附件</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            <div v-for="(item, index) in detail.attachFileList" :key="index">
                                <a :href="item.filePath">{{ item.name }}</a>
                                <!-- <a :href="item.filePath">{{detail.attachFileList}}</a> -->
                            </div>
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <!-- <div class="ch-info-item-td ch-info-item-label">公告详情</div> -->
                        <div class="ch-info-item-td ch-info-item-value" v-html="detail.content"></div>
                        <!-- <div class="ch-info-item-td ch-info-item-value">
              <span style="color: #109cee;text-decoration: underline;cursor: pointer;" @click="visible1 = true">查看公告详情</span>
            </div> -->
                    </div>
                </div>
                <div v-if="!userInfo && detail.tenderType == 0" class="ch-into-item" style="margin: 20px auto">
                    <el-button @click="goToLogin" type="danger"
                        style="margin: 0 auto; background-color: #de2c15">去登录</el-button>
                </div>
                <!--   //  tenderType 招标方式:0=线上招标 1=线下招标
          // status  项目状态 0=流标 1=已发布  2=报名中 3=待开标 4=待确定中标 5=待出结果公告  6=待出中标通知。7=已完成
          //  auditStatus 审核状态 0=待审核。1=审核通过。2=审核未通过 -->
                <div class="ch-info-buttons" v-if="detail.tenderType == 0">
                    <!-- 审核未通过/待审核-报名中 -->
                    <el-button v-if="projectInfo.auditStatus != 1 && projectInfo.status == 2" type="primary"
                        class="el-button" @click="join" :disabled="buttonDisabled">
                        {{ buttonText }}
                    </el-button>

                    <!-- this.projectInfo.status == 2 && this.projectInfo.auditStatus == '0' -->
                    <el-button type="primary" class="el-button"
                        v-if="projectInfo.auditStatus == 1 && projectInfo.auditReceiptStatus == -1"
                        @click="openDetailReceipt()">
                        上传保证金支付凭证
                    </el-button>
                    <el-button type="primary" class="el-button"
                        v-if="projectInfo.auditStatus > 0 && projectInfo.auditReceiptStatus == 0" :disabled="true">
                        保证金审核中
                    </el-button>
                    <el-button type="primary" class="el-button"
                        v-if="projectInfo.auditStatus > 0 && projectInfo.auditReceiptStatus == 2"
                        @click="openDetailReceipt()">
                        保证金驳回,请重新上传
                    </el-button>

                    <el-button v-if="
                        projectInfo.auditStatus == 1 &&
                        projectInfo.biddingFileInfo != null &&
                        projectInfo.biddingFileStatus == -1
                    " type="primary" class="el-button" @click="dialogVisibleBuyFileClick">
                        报名通过，购买招标文件
                    </el-button>

                    <el-button v-if="
                        projectInfo.auditStatus == 1 &&
                        projectInfo.biddingFileInfo == null &&
                        projectInfo.biddingFileStatus == -1
                    " type="primary" class="el-button" @click="dialogVisibleBuyFileClick" :disabled="true">
                        报名通过，等待上传标书
                    </el-button>
                    <div style="font-size: 13px; margin-top: 10px" v-if="
                        projectInfo.auditStatus == 1 &&
                        projectInfo.biddingFileInfo == null &&
                        projectInfo.biddingFileStatus == -1
                    ">
                        等待管理员上传招标文件
                    </div>
                    <el-button :disabled="true" v-if="
                        projectInfo.biddingFileStatus == 0 &&
                        [3, 4, 5, 6, 7].includes(projectInfo.status - 0)
                    " type="primary" class="el-button">
                        标书付款证明审核中
                    </el-button>

                    <el-button v-if="
                        projectInfo.biddingFileStatus != null && projectInfo.biddingFileStatus == 2
                    " type="primary" class="el-button" @click="dialogVisibleBuyFileClick">
                        标书付款证明未通过，请重新提交
                    </el-button>

                    <el-button v-if="projectInfo.biddingFileStatus == 1 && projectInfo.status > 2" type="primary"
                        @click="dialogVisibleDownFileClick" class="el-button">
                        招标文件下载
                    </el-button>
                    <!--  4=待确定中标 5=待出结果公告  6=待出中标通知。7=已完成 -->
                    <!-- <el-button 
            v-if="projectInfo.status >=3" 
            type="primary"
            class="el-button"
            :disabled="true"
            >
            报名结束啦
          </el-button> -->
                </div>
            </div>
            <!-- 资格预审公告详情 -->
            <div class="ch-info-box" v-if="typeNumber == '4'">
                <div class="ch-info-title">{{ detail.title }}</div>
                <div class="ch-info-tabel">
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">项目编号</div>
                        <div class="ch-info-item-td ch-info-item-value">{{ detail.projectCode }}</div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">采购人</div>
                        <div class="ch-info-item-td ch-info-item-value">{{ detail.purchaser }}</div>
                    </div>
                    <!-- <div class="ch-into-item">
            <div class="ch-info-item-td ch-info-item-label">采购类型</div>
            <div class="ch-info-item-td ch-info-item-value">{{ detail.biddingName }}</div>
          </div> -->

                    <div class="ch-into-item" v-if="detail.tenderType == 0">
                        <div class="ch-info-item-td ch-info-item-label">中标人</div>
                        <div class="ch-info-item-td ch-info-item-value">{{ detail.bidder }}</div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">公示期</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.publicityPeriod }}个工作日
                        </div>
                    </div>
                    <!-- <div class="ch-into-item">
            <div class="ch-info-item-td ch-info-item-label">结果公告</div>
            <div class="ch-info-item-td ch-info-item-value"><span
                style="color: #109cee;text-decoration: underline;cursor: pointer;" @click="visible2 = true">查看公告详情</span>
            </div>
          </div> -->
                     
                    <div class="ch-into-item">
                        <!--             <div class="ch-info-item-td ch-info-item-label" style="padding-top: 355px;">结果公告</div> -->
                                   
                        <div class="ch-info-item-td ch-info-item-value" v-html="contentDetail.content"></div>
                                 
                    </div>
                </div>
            </div>
            <!-- 中标结果公告详情 -->
            <div class="ch-info-box" v-if="typeNumber == '5'">
                <div class="ch-info-title">{{ detail.title }}</div>
                <div class="ch-info-tabel">
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">创建时间</div>
                        <div class="ch-info-item-td ch-info-item-value">{{ detail.createTime }}</div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">公示期</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ detail.publicityPeriod }}个工作日
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <!-- <div class="ch-info-item-td ch-info-item-label">项目编号</div> -->
                        <div class="ch-info-item-td ch-info-item-value" v-html="detail.content"></div>
                    </div>
                </div>
            </div>
            <!-- 竞价询价公告详情-->
            <div v-if="typeNumber == 6" class="ch-info-box">
                <div class="ch-info-title">{{ inqueryInfo.title }}</div>
                <div class="ch-info-tabel">
                    <div v-if="false" class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">报名费</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ inqueryInfo.priceForamt ? inqueryInfo.priceForamt : "暂无数据" }}元
                        </div>
                    </div>
                    <div v-if="false" class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">支付方式</div>
                        <el-image style="height: 100px; padding: 20px" :src="inqueryInfo.qrPayPath"
                            :preview-src-list="[inqueryInfo.qrPayPath]">
                        </el-image>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">报名时间</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ inqueryInfo.enrollStart }} 至 {{ inqueryInfo.enrollEnd }}
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">类型</div>
                        <!-- <div class="ch-info-item-td ch-info-item-value">
                            {{ dictionaryData[inqueryInfo.supplyType] }}
                        </div> -->
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ inqueryInfo.supplyTypeNames }}
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">最高限价</div>
                        <div class="ch-info-item-td ch-info-item-value">
                            {{ inqueryInfo.priceLimit }}元
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">文件</div>
                        <div class="ch-info-item-td ch-info-item-value" style="color: #3984f7; cursor: pointer">
                            {{ inqueryInfo.noticeFileName }}
                            <el-button type="text" @click="downFileC(inqueryInfo.filePath, inqueryInfo.noticeFileName)"
                                class="el-button" style="margin-left: 20px">
                                文件下载
                            </el-button>
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <!-- <div class="ch-info-item-td ch-info-item-label">公告详情</div> -->
                        <div class="ch-info-item-td ch-info-item-value" v-html="inqueryInfo.content"></div>
                    </div>
                </div>
                <div class="ch-info-buttons" v-if="typeNumber == '6'">
                    <el-button v-if="!userInfo" type="danger" style="background-color: #de2c15" class="el-button"
                        @click="goToLogin">
                        去登录
                    </el-button>

                    <el-button v-if="inqueryInfo.enrollState == 1" type="primary" class="el-button" @click="inquiry"
                        :disabled="buttonDisabled">
                        立即报名
                    </el-button>
                    <el-button v-if="inqueryInfo.enrollState == 1" type="primary" class="el-button"
                        @click="inquiryParticipation">
                        拒绝响应
                    </el-button>
                    <div style="font-size: 13px; margin-top: 10px" v-if="inqueryInfo.enrollState == 0">
                        暂时无法报名
                    </div>
                    <div style="font-size: 13px; margin-top: 10px" v-if="inqueryInfo.enrollState == -1">
                        已拒绝响应
                    </div>
                    <el-button :disabled="true" v-if="inqueryInfo.enrollState == 2" type="primary" class="el-button">
                        询价付款证明审核中
                    </el-button>

                    <el-button v-if="inqueryInfo.enrollState == 3" type="primary" class="el-button" @click="inquiry">
                        询价付款证明未通过，请重新提交
                    </el-button>
                    <el-button v-if="inqueryInfo.enrollState == 4" type="primary" class="el-button"
                        @click="secondInquiry" :disabled="false">
                        可以进行报价并提交竞价文件
                    </el-button>
                    <el-button v-if="inqueryInfo.enrollState == 5" type="primary" class="el-button" :disabled="true">
                        已报名
                    </el-button>
                    <el-button v-if="inqueryInfo.enrollState == 6" type="primary" class="el-button" :disabled="true">
                        报名已经结束啦~
                    </el-button>
                </div>
            </div>

            <!--竞价询价 结果公告-->
            <div class="ch-info-box" v-if="typeNumber == '7'">
                <div class="ch-info-title">{{ detail.title }}</div>
                <div class="ch-info-tabel">
                    <div class="ch-into-item">
                        <!-- <div class="ch-info-item-td ch-info-item-label">项目编号</div> -->
                        <div class="ch-info-item-td ch-info-item-value" v-html="detail.content"></div>
                    </div>
                </div>
            </div>
        </el-card>

        <!-- 招标公告报名 -->
        <el-dialog title="招标公告报名" :visible.sync="dialogVisible" width="80%">
            <div>
                <div v-if="false">
                    <p>付款截图</p>
                    <el-upload :action="actionUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove" :file-list="payFileList" :headers="headersObj" :limit="1" :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 1)
                            ">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </div>
                <div v-if="buttonText == '去报名' || buttonText == '再次报名'">
                    <p>资料文件上传</p>
                    <el-upload :action="actionUrl" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                        :file-list="fileList" :headers="headersObj" :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 2)
                            ">
                        <el-button type="primary">资料文件上传</el-button>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleClick">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 询价竞价报名 -->
        <el-dialog :close-on-click-modal="false" title="采购报名" :visible.sync="dialogVisible1" width="30%">
            <div>
                <div v-if="true || inqueryInfo.enrollState == 4">
                    <p>报价金额</p>
                    <el-input @input="
                        inquiryBody.quotedAmount = inquiryBody.quotedAmount.replace(/[^0-9.]/g, '')
                        " v-model="inquiryBody.quotedAmount" placeholder="请输入报价金额" size="small" style="width: 200px">
                        <template #append>元</template>
                    </el-input>
                </div>

                <!-- <div>
          <p>下浮比例</p>
          <el-input
            @input="
              inquiryBody.downwardFloatRate = inquiryBody.downwardFloatRate.replace(
                /[^0-9.]/g,
                ''
              )
            "
            v-model="inquiryBody.downwardFloatRate"
            placeholder="请输入下浮比例"
            size="small"
            style="width: 200px"
          >
            <template #append>%</template>
          </el-input>
        </div> -->

                <div v-if="true || inqueryInfo.enrollState == 4">
                    <p>响应上传</p>
                    <el-upload :action="actionUrl" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                        :file-list="fileList" :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 5)
                            ">
                        <el-button type="primary">响应文件上传</el-button>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleClick1">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 提交报价金额和响应 -->
        <el-dialog title="询价竞价报价、文件上传" :visible.sync="dialogVisible2" width="40%">
            <div>
                <div v-if="inqueryInfo.enrollState !== 4">
                    <p>付款截图</p>
                    <el-upload :action="actionUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove" :file-list="payFileList" :limit="1" :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 4)
                            ">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </div>
                <div v-if="inqueryInfo.enrollState == 4">
                    <p>报价金额</p>
                    <el-input @input="
                        inquiryPriceBody.quotedAmount = inquiryPriceBody.quotedAmount.replace(
                            /[^0-9.]/g,
                            ''
                        )
                        " v-model="inquiryPriceBody.quotedAmount" placeholder="请输入报价金额" size="small"
                        style="width: 200px" />
                </div>
                <div v-if="inqueryInfo.enrollState == 4">
                    <p>响应上传</p>
                    <el-upload :action="actionUrl" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                        :file-list="fileList" :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 5)
                            ">
                        <el-button type="primary">响应上传</el-button>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleClick2">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 购买标书 -->
        <el-dialog title="购买标书" :visible.sync="dialogVisibleBuyFile" width="60%">
            <div>
                <p>
                    <span>发售方式：</span>
                    <span>{{ fileData.saleTypeName }}</span>
                </p>
                <p>
                    <span>发售价格：</span>
                    <span>{{ fileData.price }}元</span>
                </p>
                <el-select v-model="buyBody.payType" placeholder="请选择付款方式">
                    <el-option label="微信" :value="1"></el-option>
                    <el-option label="支付宝" :value="2"></el-option>
                    <el-option label="银联" :value="3"></el-option>
                </el-select>
                <div>
                    <p>付款截图</p>
                    <el-upload :action="actionUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove" :file-list="payFileList" :headers="headersObj" :limit="1" :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 3)
                            ">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </div>
            </div>
            <el-table border :data="[fileData]" style="width: 100%; margin-top: 20px">
                <el-table-column :show-overflow-tooltip="true" prop="fileName" label="招标文件">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="uploadTime" label="上传时间">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleBuyFile = false">取 消</el-button>
                <el-button type="primary" @click="buyClick">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 招标公告 -->
        <el-dialog title="公告详情" :visible.sync="visible1" width="80%">
            <div>
                <div class="ch-info-tabel">
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-value" v-html="detail.content"></div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible1 = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 结果公告 -->
        <el-dialog title="结果公告详情" :visible.sync="visible2" width="80%" v-if="typeNumber == '4'">
            <div>
                <div class="ch-info-tabel">
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-value" v-html="contentDetail.content"></div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible2 = false">取 消</el-button>
            </span>
        </el-dialog>

        <!--保证金  -->
        <el-dialog center title="保证金" :visible.sync="receiptModal" width="800px">
            <div>
                <div class="receiptClass">
                    <div class="laberlTitle">开户行</div>
                    <div class="infoClass">{{ bondInfoObj.bankName }}</div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">开户名</div>
                    <div class="infoClass">{{ bondInfoObj.name }}</div>
                </div>
                <div class="receiptClass">
                    <div class="laberlTitle">银联支付账号</div>
                    <div class="infoClass">{{ bondInfoObj.unionPay }}</div>
                </div>
                <div class="receiptClass">
                    <div class="laberlTitle">保证金金额</div>
                    <div class="infoClass">{{ projectInfo.bond }}</div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">微信收款码</div>
                    <div class="infoClass">
                        <el-image style="width: 60px" :src="bondInfoObj.imgWechatFileUrl"
                            :preview-src-list="[bondInfoObj.imgWechatFileUrl]">
                        </el-image>
                    </div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">支付宝收款码</div>
                    <div class="infoClass">
                        <el-image style="width: 60px" :src="bondInfoObj.imgAlipayFileUrl"
                            :preview-src-list="[bondInfoObj.imgAlipayFileUrl]">
                        </el-image>
                    </div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">缴纳时间</div>
                    <div class="infoClass">
                        {{ bondInfoObj.startTime }}至{{ bondInfoObj.endTime }}
                    </div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">保证金支付凭证/保函/保单</div>
                    <div class="infoClass">
                        <el-upload :file-list="receiptFileList" :action="actionUrl" :headers="Authorization"
                            :on-remove="handleRemove" :on-success="(res, file, fileList) => uploadContractSuccess(res, file, fileList, 2)
                                " :limit="1">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="receiptModal = false">取 消</el-button>
                <el-button v-loading="fileVisibleLoading" type="primary" @click="receiptSave">确 定</el-button>
            </span>
        </el-dialog>

        <!--  -->
        <!-- 询价竞价报名 -->
        <el-dialog title="采购不参与" :visible.sync="dialogVisibleParticipation" width="30%">
            <div>
                <p>说明文件上传</p>
                <el-upload :action="actionUrl" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                    :file-list="fileList" :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 6)
                        ">
                    <el-button type="primary">说明文件上传</el-button>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleParticipation = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleClick3">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 情况说明列表 -->
        <div v-if="sibleituationData.length != 0" class="SibleituationClass">
            <div>
                <div style="text-align: center; margin-bottom: 10px; font-weight: 600">
                    情况说明
                </div>
                <el-table :data="sibleituationData" stripe :show-header="false" max-height="500">
                    <el-table-column prop="title" label="标题">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="light" :content="scope.row.title" placement="top">
                                <el-link class="ellipsis-tooltip" @click="changeSibleituation(scope.row)" type="primary"
                                    :underline="false">
                                    {{ scope.row.title }}
                                </el-link>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="false" prop="fileName" label="文件名称">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="light" :content="scope.row.filePath" placement="top">
                                <span class="ellipsis-tooltip">{{ scope.row.filePath }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="时间" width="170"></el-table-column>
                </el-table>
            </div>
        </div>

        <el-dialog title="情况说明详情" :visible.sync="dialogViSibleituation" width="60%">
            <div class="ch-info-box">
                <div class="ch-info-title">{{ sibleituationInfo.title }}</div>
                <div class="ch-info-tabel">
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-label">文件</div>
                        <div class="ch-info-item-td ch-info-item-value" style="color: #3984f7; cursor: pointer">
                            {{ sibleituationInfo.fileName }}
                            <el-button type="text"
                                @click="downFileC(sibleituationInfo.filePath, sibleituationInfo.fileName)"
                                class="el-button" style="margin-left: 20px">
                                文件下载
                            </el-button>
                        </div>
                    </div>
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-value" v-html="sibleituationInfo.content"></div>
                    </div>
                </div>
            </div>
            <el-table :data="sibleituationData" stripe max-height="500" v-if="false">
                <el-table-column prop="title" label="标题" width="300"></el-table-column>
                <el-table-column v-if="false" prop="fileName" label="文件名称">
                    <template slot-scope="scope">
                        <el-link @click="downFile(scope.row.filePath)" type="primary" :underline="false">{{
                            scope.row.fileName }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="时间" width="180"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { Message } from "element-ui";
import req from "@/api/config/config";
import home from "@/api/home/index";
import announcement from "@/api/announcement/announcement";

export default {
    mounted () {
        // if (window.history && window.history.pushState) {
        //     // 向历史记录中插入了当前页
        //     history.pushState(null, null, document.URL);
        //     window.addEventListener('popstate', this.goBack, false);
        // }
    },
    destroyed () {
        // window.removeEventListener('popstate', this.goBack, false);
    },
    created () {
        this.dictionary();
        this.userInfo = localStorage.getItem("userInfo") ?? false;
        // console.log("获取的参数", this.$route.query);
        if (localStorage.getItem("TencentNews") != null && this.typeNumber) {
            this.typeNumber = this.$route.query.type;
            this.id = this.$route.query.id;
            if (this.typeNumber == 6) {
                this.TencentNews = localStorage.getItem("TencentNews");
                // console.log(this.TencentNews,'从详情页面进入的this.TencentNews数据是5');
                localStorage.setItem("beforeTencentNews", 5);
                this.queryInquiryDetail();
            } else if (this.typeNumber == 7) {
                announcement.resultInfo(this.$route.query.noticeId).then((res) => {
                    this.detail = res.data;
                });
                this.TencentNews1 = localStorage.getItem("TencentNews");
                localStorage.setItem("beforeTencentNews1", 6);
                // console.log(this.TencentNews1,'从详情页面进入的this.TencentNews1');
            } else {
                this.queryNewBulletinDetail();
            }
        } else {
        }
        // this.bondInfo()
    },
    data () {
        return {
            receiptModal: false,
            receiptObj: {},
            bondInfoObj: {},
            receiptFileList: [],
            userInfo: {},
            visible1: false, // 招标公告弹窗
            visible2: false, // 结果公告弹窗
            typeNumber: 2,
            id: 1,
            actionUrl: req.systemIp + "/sysFileInfo/upload",
            dialogVisible: false,
            dialogVisible1: false,
            dialogVisible2: false,
            projectId: "",
            projectInfo: {},
            inqueryInfo: {},
            addrdata: {},
            detail: {},
            contentDetail: {},
            paymentType: "",
            buttonDisabled: false,
            tenderSaleType: "",
            buttonText: "立即报名",
            isNew: true,
            projectStatusList: {},
            headersObj: {
                // Authorization:"Bearer "+JSON.parse(localStorage.getItem('userInfo'))?.access_token
            },
            payFileList: [],
            fileList: [],
            enrollBody: {
                fileList: [],
                payFile: "", //付款文件ID
                noticeId: "", //公告id
            },

            dialogVisibleBuyFile: false,
            fileData: {},
            buyBody: {
                projectId: "",
                payType: 1,
                payFile: "",
                remark: "",
            },
            inquiryBody: {
                noticeId: "",
                payFile: "",
            },
            inquiryPriceBody: {
                noticeId: "",
                quotedAmount: "", //报价金额,
                downwardFloatRate: "", //下浮比例
                fileId: "", //文件id
            },
            dialogVisibleDownFile: false,
            TencentNews: "",
            TencentNews1: "",
            dictionaryData: {},
            dialogVisibleParticipation: false,
            participationBody: {
                noticeId: "",
                reasonFile: "",
            },
            dialogViSibleituation: false,
            sibleituationData: [],
            sibleituationInfo: {},
        };
    },
    methods: {
        changeSibleituation (rowData) {
            this.sibleituationInfo = rowData;
            this.dialogViSibleituation = !this.dialogViSibleituation;
        },
        downFile (filePath) {
            window.open(
                filePath,
                "_blank" // 特殊名称，始终打开新标签页
            );
        },
        situationPage (inquiryNoticeIdData) {
            announcement
                .situationPage({ page: 1, limit: 500, inquiryNoticeId: inquiryNoticeIdData })
                .then((res) => {
                    this.sibleituationData = res.data.list;
                });
        },
        inquiryParticipation () {
            this.dialogVisibleParticipation = true;
        },
        /**
         * 不参与报价
         */
        dialogVisibleClick3 () {
            this.participationBody.noticeId = this.$route.query.id;
            if (!this.participationBody.reasonFile) {
                this.$message.error("请上传文件");
                return;
            }
            this.$confirm(`确定不参与该采购吗?`, "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(() => {
                    announcement.reject(this.participationBody).then((res) => {
                        if (res.code == 0) {
                            this.$router.go(0);
                            this.dialogVisibleParticipation = false;
                            this.queryNewBulletinDetail(); //结果公告
                            Message.success(res.message);
                        } else {
                            Message.error(res.message);
                        }
                    });
                })
                .catch(() => { });
        },
        dictionary () {
            home.dictionary({ code: "supplier" }).then((res) => {
                this.dictionaryList = res.data;
                let resData = {};
                res.data.forEach((element) => {
                    resData[element.code] = element.value;
                });
                this.dictionaryData = resData;
            });
        },
        openDetailReceipt () {
            this.receiptModal = true;
            this.receiptObj.projectId = this.$route.query.projectId;
        },
        receiptSave () {
            announcement.receipt(this.receiptObj).then((res) => {
                if (res.code == 0) {
                    this.receiptFileList = [];
                    this.receiptModal = false;
                    this.$message.success(res.message);
                    this.queryNewBulletinDetail(); //结果公告
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        bondInfo () {
            announcement.bondInfo(this.$route.query.projectId).then((res) => {
                if (res.code == 0) {
                    this.bondInfoObj = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        uploadContractSuccess (res, file, fileList, index) {
            if (res?.data?.fileId) {
                if (index == 2) {
                    //保证金上传
                    this.receiptObj.payFile = res.data.fileId;
                }
            } else {
                this.receiptFileList = [];
                this.$message.error("登录已过期，请刷新页面后重新登录");
                // localStorage.clear();
                localStorage.removeItem("userInfo");
                localStorage.removeItem("orgInfo");
                setTimeout(function () {
                    location.href = "#/choice";
                }, 1000);
            }
        },
        goBack () {
            console.log("点击了浏览器的返回按钮");
            sessionStorage.clear();
            window.history.back();
            history.pushState(null, null, document.URL);
        },
        goToLogin () {
            this.$router.push("/choice");
        },
        handlePictureCardPreview () { },

        downFileC (filePath, fileName) {
            if (!this.userInfo) {
                this.$message.warning('请先登录')
                return false
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = filePath;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        handleRemove () { },
        dialogVisibleDownFileClick () {
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = this.projectInfo.biddingFileInfo.filePath;
            link.setAttribute("download", this.projectInfo.biddingFileInfo.fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        dialogVisibleBuyFileClick () {
            announcement.fileInfo({ projectId: this.$route.query.projectId }).then((res) => {
                if (res.code == 0) {
                    if (res.data) {
                        this.fileData = res.data;
                        this.dialogVisibleBuyFile = true;
                    } else {
                        Message.error("数据请求异常，请联系管理员");
                    }
                }
            });
        },
        // 询价竞价公告报名
        // dialogVisibleInquiryFileClick() {
        //   announcement.inquiryOrderInfo({ projectId: this.$route.query.projectId }).then(res => {
        //     if (res.code == 0) {
        //       if (res.data) {
        //         this.fileData = res.data
        //         this.dialogVisibleBuyFile = true
        //       } else {
        //         Message.error('数据请求异常，请联系管理员')
        //       }
        //     }
        //   })
        // },
        buyClick () {
            this.buyBody.projectId = this.$route.query.projectId;
            announcement.orderBuy(this.buyBody).then((res) => {
                if (res.code == 0) {
                    this.$router.go(0);
                }
            });
        },
        // 招标公告报名信息保存
        dialogVisibleClick () {
            this.enrollBody.projectId = this.$route.query.projectId;
            announcement.enroll(this.enrollBody).then((res) => {
                if (res.code == 0) {
                    this.$router.go(0);
                    this.dialogVisible = false;
                    this.queryNewBulletinDetail(); //结果公告
                    Message.success(res.message);
                } else {
                    Message.error(res.message);
                }
            });
        },
        formatCurrency (amount) {
            return new Intl.NumberFormat("zh-CN", {
                style: "currency",
                currency: "CNY",
                currencyDisplay: "code",
            })
                .format(amount)
                .replace("CNY", "");
        },

        // 询价竞价报名信息保存
        dialogVisibleClick1 () {
            let dataAmount = this.inquiryBody.quotedAmount;
            let downwardFloatRate = this.inquiryBody.downwardFloatRate;
            if (!dataAmount) {
                this.$message.error("请输入报价");
                return;
            }
            // if (!downwardFloatRate) {
            //   this.$message.error("请输入下浮比例");
            //   return;
            // }
            // if (downwardFloatRate < 0 || downwardFloatRate >= 100) {
            //   this.$message.error("请输入正确的下浮比例，下浮比例在1到100之间");
            //   return;
            // }
            if (dataAmount > this.inqueryInfo.priceLimit) {
                this.$message.error("报价不能高于最高限价");
                return;
            }
            this.$confirm(
                // `您的报价为：${this.formatCurrency(
                //   dataAmount
                // )}元，下浮比例为：${downwardFloatRate}%，是否确认报价?如果存在纸质报价文件，本次报价与下浮比例必须与纸质报价文件中的报价与下浮比例一致，否则按照废标处理`,
                // "提示",
                `您的报价为：${this.formatCurrency(
                    dataAmount
                )}元，是否确认报价?如果存在纸质报价文件，本次报价必须与纸质报价文件中的报价一致，否则按照废标处理`,
                "提示",
                {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true,
                }
            )
                .then(() => {
                    this.inquiryBody.noticeId = this.$route.query.id;

                    announcement.inquiryOrderInfo(this.inquiryBody).then((res) => {
                        if (res.code == 0) {
                            // this.$router.go(0)
                            this.dialogVisible1 = false;
                            this.queryInquiryDetail();
                            Message.success(res.message);
                        } else {
                            Message.error(res.message);
                        }
                    });
                })
                .catch(() => { });
        },
        // 询价竞价报价金额和询价文件
        dialogVisibleClick2 () {
            this.inquiryPriceBody.noticeId = this.$route.query.id;
            announcement.inquiryPriceAndFilmInfo(this.inquiryPriceBody).then((res) => {
                if (res.code == 0) {
                    this.$router.go(0);
                    this.dialogVisible2 = false;
                    this.queryNewBulletinDetail(); //结果公告
                    Message.success(res.message);
                } else {
                    Message.error(res.message);
                }
            });
        },

        onSuccess (response, file, fileList, index) {
            if (index == 1) {
                //招标公告付款截图
                this.enrollBody.payFile = response.data.fileId;
            }
            if (index == 2) {
                //招标文件资料文件上传
                this.enrollBody.fileList = fileList.map((item) => {
                    return {
                        fileId: item.response.data.fileId,
                    };
                });
            }

            if (index == 3) {
                //购买标书付款截图
                this.buyBody.payFile = response.data.fileId;
            }
            // 询价竞价公告
            if (index == 4) {
                //询价竞价付款截图
                this.inquiryBody.payFile = response.data.fileId;
            }
            if (index == 5) {
                //响应
                this.inquiryBody.fileId = response.data.fileId;
            }
            if (index == 6) {
                //不参与响应文件
                this.participationBody.reasonFile = response.data.filePathCode;
            }
        },
        // 公告详情
        queryNewBulletinDetail () {
            this.TencentNews = localStorage.getItem("TencentNews");
            // console.log(this.TencentNews,'从详情页面进入的this.TencentNews');
            localStorage.setItem("beforeTencentNews", this.TencentNews);
            let obj = {
                noticeId: this.$route.query.noticeId,
            };
            announcement.queryBulletinDetail(obj).then((res) => {
                let data = res.data;
                this.detail = res.data;
                this.contentDetail = res.data;
                if (data.signPreTrial == 1) {
                    this.buttonText = "提交资格预审";
                }
                if (res.data.paymentType === 1) {
                    this.paymentType = "按项目收款";
                } else {
                    this.paymentType = "接包收款";
                }

                if (res.data.tenderSaleType === 1) {
                    this.tenderSaleType = "在线发售（电子版）";
                } else if (res.data.tenderSaleType === 2) {
                    this.tenderSaleType = "邮件发售（电子版）";
                } else if (res.data.tenderSaleType === 3) {
                    this.tenderSaleType = "邮寄发货（纸质版）";
                }
                // if (res.data.signType !== 2) {
                //   this.buttonDisabled = true;
                //   this.buttonText = "已结束"
                // }
                // if (res.data.isNew === 0) {
                //   this.isNew = true;
                // } else {
                //   this.isNew = false;
                //   this.buttonText = "此项目公告已更正，请查看更正公告";
                //   this.buttonDisabled = true;
                // }
            });

            if (this.typeNumber != "5") {
                let userInfo = localStorage.getItem("userInfo");
                if (!userInfo) {
                    return;
                }
                announcement
                    .projectDetail({ projectId: this.$route.query.projectId })
                    .then((res) => {
                        if (res.code == 0) {
                            this.projectInfo = res.data;
                            // console.log("项目信息",this.projectInfo)
                            //  tenderType 招标方式:0=线上招标 1=线下招标
                            // status  项目状态 0=流标 1=已发布  2=报名中 3=待开标 4=待确定中标 5=待出结果公告  6=待出中标通知。7=已完成
                            //  auditStatus 审核状态 0=待审核。1=审核通过。2=审核未通过
                            if (
                                this.projectInfo.tenderType == 0 &&
                                this.projectInfo.status == 2 &&
                                this.projectInfo.auditStatus == null
                            ) {
                                // 线上-报名中-
                                if (!this.userInfo) {
                                    this.buttonText = "去登录";
                                } else {
                                    this.buttonText = "去报名";
                                }

                                this.buttonDisabled = false;
                            } else if (
                                this.projectInfo.status == 2 &&
                                this.projectInfo.auditStatus == "0"
                            ) {
                                // 报名中-待审核
                                this.buttonText = "报名审核中";
                                this.buttonDisabled = true;
                            } else {
                                this.buttonText = "再次报名";
                                this.buttonDisabled = false;
                            }
                            // else{
                            //   this.buttonText = "报名结束啦"
                            //    this.buttonDisabled = true;
                            // }
                        }
                    });
            }
        },
        // 询价竞价公告详情
        queryInquiryDetail () {
            let obj = {
                id: this.$route.query.id,
            };
            if (!this.userInfo) {
                announcement.inqueryDetailNoLogin(this.$route.query.id).then((res) => {
                    this.inqueryInfo = res.data;
                });
            } else {
                announcement.inqueryDetail(obj).then((res) => {
                    this.inqueryInfo = res.data;
                });
            }
            this.situationPage(this.$route.query.id);
        },
        // 招标公告报名
        join () {
            if (!this.$CA.getSignCertInfo()) {
                this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
                return;
            }
            let userInfo = localStorage.getItem("userInfo");
            this.dialogVisible = true;
            if (!userInfo) {
                Message.warning("请登录");
                location.href = "#/choice";
                return;
            }
        },
        // 询价竞价报名
        inquiry () {
            let userInfo = localStorage.getItem("userInfo");
            // console.log(userInfo,'userInfo');
            this.dialogVisible1 = true;
        },
        // 提交报价并上传竞价文件
        secondInquiry () {
            let userInfo = localStorage.getItem("userInfo");
            // console.log(userInfo,'userInfo');
            this.dialogVisible2 = true;
        },
    },
};
</script>
<style>
.ch-info-item-value img {
    width: 100% !important;
}
</style>
<style lang="less" scoped>
.ellipsis-tooltip {
    display: inline-block;
    max-width: 100%;
    /* 确保不超过父容器宽度 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ch-container {
    width: 100% !important;
}

.SibleituationClass {
    position: fixed;
    right: 10px;
    bottom: 70vh;
    background: #fff;
    height: auto;
    border-radius: 10px;
    border: 1px solid;
    border-color: #b2b2b2;
    padding: 5px;
    margin-right: 10px;
    box-sizing: border-box;
    z-index: 99;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    width: 390px;

    .commonClass {
        text-align: center;
        padding: 0px 5px;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        color: #aaa;
        position: relative;

        :hover {
            background: #000000;
            color: #fff;
            border-radius: 10px;
        }
    }
}

.receiptClass {
    display: flex;
    border-bottom: 1px solid #ffffff;
    font-size: 16px;

    .laberlTitle {
        width: 20%;
        text-align: right;
        padding: 10px;
        background: #eee;
    }

    .infoClass {
        padding: 10px;
        background: #fafafa;
        flex: 1;
    }
}

.ch-info-box {
    width: 880px;
    padding: 25px 0;
    margin: auto;
}

.ch-info-title {
    font-size: 24px;
    font-weight: 400;
    color: #666666;
    line-height: 42px;
    margin-bottom: 35px;
    text-align: center;
}

.ch-info-tabel {
    border: solid 1px #efefef;
}

.ch-into-item {
    display: flex;

    >.ch-info-item-td {
        padding: 20px 30px;
        box-sizing: border-box;
    }

    >.ch-info-item-td+.ch-info-item-td {
        border-left: solid 1px #efefef;
    }
}

.ch-info-item-label {
    background-color: #f9f9f9;
    font-size: 14px;
    width: 330px !important;
    color: #343434;
}

.ch-info-item-value {
    font-size: 14px;
    color: #343434;
    flex: 1;

    img {
        width: 100%;
    }
}

.ch-into-item+.ch-into-item {
    border-top: solid 1px #efefef;
}

.ch-info-buttons {
    margin-top: 35px;
    text-align: center;

    .el-button {
        padding-left: 40px;
        padding-right: 40px;
    }
}
</style>
